module.exports = __webpack_public_path__ + "static/media/AI艺术banner.73ff2dae.jpg";